import { Directive, HostBinding } from '@angular/core';

@Directive({
	selector: '[vpTooltipContent]',
	standalone: true,
})
export class TooltipContentDirective {
	@HostBinding('attr.data-test-id') readonly testId = 'tooltip-content';
}
